import Lang from "@vendors-fr/messages";
import 'jquery-confirm';
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import {
    rentalCertificateData,
    getRentalUnusedCodeHtml,
    getRentalUsedCodeHtml,
    getRentalProductDetailHtml
} from "@plugins-fr/rentalCertificate";

$(document).ready(function(){
    let JS_VARS = JSON.parse(shops);
    let JS_VARS_THEME_STYLE = JSON.parse(themeButtonStyle);


    const getUnusedReservationCodesOptionsHtml = function (reservation) {

        let html = '';

        if (reservation.status === 'used') {
            return html;
        }

        if (reservation.status === 'unused') {
            html = `
                <div class="c-checkBorderbox js_check_effect_container" data-check-style="${JS_VARS.styles.verificationCheckedBorderStyle}">
                    <label class="c-checkBorderbox__label">
                        <input type="checkbox" class="c-checkBorderbox__input js_choose_appointment js_check_effect_input d-none" name="verificationCode" value="${ reservation.code }">
                        <span class="c-checkBorderbox__check js_check_effect_check" data-check-style="${JS_VARS.styles.verificationCheckedCheckboxStyle}">
                            <i class="c-checkBorderbox__icon icon-checkmark1"></i>
                        </span>
                        <span class="c-checkBorderbox__text js_check_effect_text" data-check-style="${JS_VARS.styles.verificationCheckedSpanStyle}">${ Lang.get('frontend.order.reservation.verificationCode') } : ${ reservation.code }</span>
                    </label>
                </div>
            `;
        }else {
            html = `
                <div class="c-checkBorderbox c-checkBorderbox--status js_check_effect_container">
                    <label class="c-checkBorderbox__label">
                        <span class="c-checkBorderbox__text js_check_effect_text">${ Lang.get('frontend.order.reservation.verificationCode') }：${ reservation.code }</span>
                    </label>
                    <span class="c-square-tag c-square-tag--sm c-square-tag--outline">${ reservation.status === 'cancel'?Lang.get('frontend.order.status.canceled'):Lang.get('frontend.order.status.error') }</span>
                </div>
            `;
        }

        return html;
    };

    const getUsedReservationCodesHtml = function (reservation) {
        return `
            <div class="c-infoBorderBox">
                <div class="c-infoBorderBox__infos">
                    <p class="ui-font-bold">${ Lang.get('frontend.order.reservation.verificationCode') }：${reservation.code}</p>
                    <p>${ Lang.get('frontend.order.reservation.verificationTime') }：${reservation.verification_at}</p>
                </div>
                <div class="c-square-tag c-square-tag--sm c-square-tag--outline">${ Lang.get('frontend.order.reservation.verificationSuccess') }</div>
            </div>
        `;
    };

    const renderNoData = function (desc) {
        return `<p class="c-tab__noData w-100">${desc}</p>`;
    };

    const getReservationCodeDetailHtml = function (code, verificationTime) {
        return `
            <div class="c-infoBorderBox">
                <div class="c-infoBorderBox__infos">
                    <p class="ui-font-bold">${ Lang.get('frontend.order.reservation.verificationCode') }：${ code }</p>
                    <p>${ Lang.get('frontend.order.reservation.verificationTime') }：${ verificationTime }</p>
                </div>
                <div class="c-square-tag c-square-tag--sm c-square-tag--outline c-square-tag--success">${ Lang.get('frontend.order.reservation.verificationSuccess') }</div>
            </div>
        `;
    };

    $('.js_appointment_btn').on("click", function(){

        const reservationId = $(this).data('reservation-id');
        const reservationBlockDom = $('#js_reservation_' + reservationId);
        const reservationTime = reservationBlockDom.find('.js_reservation_time').text();

        $.confirm({
            backgroundDismiss: false,
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_appointment js_appointment_pop'
            }),
            columnClass: 'col-lg-5',
            closeIcon: false,
            icon: '',
            animation: 'opacity',
            animationSpeed: 1000,
            animateFromElement: false,
            closeAnimation: 'none',
            title: `${ Lang.get('frontend.product.service.reservationTime') }：${reservationTime}`,
            theme: 'el_confirm el_popup_appointment js_appointment_pop',
            keyboardEnabled: true,
            content: $(".js_appointment_popup_used").html(),
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.close') + '</span>',
                    btnClass: 'js_cancel btn_cancel btn el_btn md solid el_rounded el_text m-0 order-first',
                    action: function () {
                        $('.js_appointment_check_error').hide();
                        this.$el.find('[data-tab-panel]').eq(0).trigger('click');
                    }
                },
                confirmButton: {
                    keys: ['enter'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.order.reservation.verificationCertificate') + '</span>',
                    btnClass: 'js_use_appointment js_confirm btn_confirm btn el_btn md solid el_rounded el_text m-0',
                    action: function () {
                        const checkedCodeNumber = $('.js_choose_appointment:checked').length;
                        if(checkedCodeNumber === 0) {
                            $('.js_appointment_check_error').show();
                            return false;
                        } else {
                            $('.js_appointment_pop').hide();

                            let verificationCodes = [];
                            $.each($('.js_choose_appointment:checked'), function (index, checkedAppointment) {
                                verificationCodes.push($.trim($(checkedAppointment).val()));
                            });

                            secondPopup('reservation', $('.js_appointment_pop'), reservationTime, verificationCodes);
                        }
                        return false;
                    }
                }
            },
            onOpenBefore: function() {
                const reservationBlockDom = $('#js_reservation_' + reservationId);
                const unusedReservationBlockDom = $('.js_appointment_order_list_pending');
                const usedReservationBlockDom = $('.js_appointment_order_list_activate');

                const reservationProductName = reservationBlockDom.find('.js_reservation_product_name').text();
                const reservationImg = reservationBlockDom.find('.js_reservation_img').attr('src');
                const reservationTime = reservationBlockDom.find('.js_reservation_time').text();
                const reservationDuration = reservationBlockDom.find('.js_reservation_duration').text();
                const reservationQuantity = Number(reservationBlockDom.find('.js_accepted_reservation_quantity').text()) + Number(reservationBlockDom.find('.js_canceled_reservation_quantity').text());
                const reservationCodes = JS_VARS.reservationCodesGroupById[reservationId];

                $('.js_appointment_popup_used').attr('data-reservation-id', reservationId);

                $('.js_appointment_photo').attr('src', reservationImg);
                $('.js_appointment_name b').text(reservationProductName);
                $('.js_appointment_appointTime').text(reservationTime);
                $('.js_appointment_number').text(reservationQuantity);
                $('.js_appointment_duration').text(reservationDuration);

                // 已使用、未使用頁籤
                let usedReservationCodeAmount = 0;
                let usedReservationCodesHtml = '';
                let unusedReservationCodesOptionsHtml = '';
                $.each(reservationCodes, function (index ,reservationCode) {
                    if (reservationCode.status === 'used') {
                        usedReservationCodesHtml += getUsedReservationCodesHtml(reservationCode);
                        usedReservationCodeAmount ++;
                    } else {
                        unusedReservationCodesOptionsHtml += getUnusedReservationCodesOptionsHtml(reservationCode);
                    }
                });

                if (usedReservationCodesHtml !== '') {
                    usedReservationBlockDom.html(usedReservationCodesHtml);
                } else {
                    usedReservationBlockDom.html(renderNoData(Lang.get('frontend.order.reservation.used.noData')));
                }

                if (unusedReservationCodesOptionsHtml !== '') {
                    unusedReservationBlockDom.html(unusedReservationCodesOptionsHtml);
                } else {
                    unusedReservationBlockDom.html(renderNoData(Lang.get('frontend.order.reservation.unused.noData')));
                }

                $('.js_appointment_unused').text(reservationCodes.length - usedReservationCodeAmount);
                $('.js_appointment_used').text(usedReservationCodeAmount);

                // 詳細說明頁籤
                $('.js_appointment_ticket_text').text(reservationBlockDom.data('ticket-manual'));
                $('.js_appointment_ticket_info_text').text(reservationBlockDom.data('ticket-information'));

                let checkedNumber = 0;

                this.$el.find('[data-tab]').on('click', '[data-tab-panel]' ,function() {
                    const type = $(this).data('tab-panel');
                    $(this).addClass('is-active').siblings('[data-tab-panel]').removeClass('is-active');
                    $(`[data-tab-content="${type}"]`).removeClass('d-none').siblings('[data-tab-content]').addClass('d-none');
                })

                this.$el.find('.js_check_effect_input').on('change',function(){
                    const $this = $(this);
                    const $container =  $this.parents('.js_check_effect_container');
                    const $checked =  $container.find('.js_check_effect_check');
                    const $text =  $container.find('.js_check_effect_text');

                    const addStyle = ($el) => {
                        $el.attr('style', $el.data('check-style'));
                    }

                    const removeStyle = ($el) => {
                        $el.removeAttr('style', $el.data('check-style'));
                    }

                    if( $this.prop('checked')){
                        addStyle($container);
                        addStyle($checked);
                        addStyle($text);
                        checkedNumber++;
                    }else {
                        removeStyle($container);
                        removeStyle($checked);
                        removeStyle($text);
                        checkedNumber--;
                    }

                    $('.js_choose_appointment').text(checkedNumber);
                });

                this.$el.find('.js_confirm').attr('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                this.$el.find('.js_confirm').data('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                this.$el.find('.js_confirm').data('hover-style', JS_VARS_THEME_STYLE.mainButtonHoverStyle);

                this.$el.find('.js_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.js_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.js_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

            }
        });

    });

    function secondPopup(verificationType, parentModal, bookingTime, verificationCodes)
    {
        const fetchQrCodeUrl = (verificationCodes) => {
            return new Promise((resolve, reject) => {
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: '/order/qrCodeUrlToTicketAdmin',
                    data: {
                        verificationType: verificationType,
                        verificationCodes: verificationCodes,
                    },
                    success: function (result) {
                        resolve(result);
                    },
                    error: function (jqXHR, exception) {
                        console.error(jqXHR);
                        console.error(exception);
                        resolve({
                            status: false,
                            errorMessage: '系統忙碌中，請稍後再試。',
                            url: '',
                        });
                    }
                });
            });
        };

        $.confirm({
            backgroundDismiss: false,
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_appointment js_appointment_pop2'
            }),
            columnClass: 'col-lg-5',
            closeIcon: false,
            icon: '',
            animation: 'opacity',
            animationSpeed: 1000,
            closeAnimation: 'none',
            title: `${ Lang.get('frontend.product.service.reservationTime') }：${bookingTime}`,
            keyboardEnabled: true,
            content: $(".js_appointment_check_area").html(),
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.return') + '</span>',
                    btnClass: 'js_cancel btn_cancel btn el_btn md solid el_rounded el_text m-0 order-first',
                    action: function () {
                        parentModal.show();
                    }
                }
            },
            onOpenBefore: async function() {
                $('.js_appointment_ticket_no').text(verificationCodes.join("、"));
                $('.js_appointment_ticket_no').data('reservation-code', verificationCodes.join("、"));

                // 核銷QRCode
                if (JS_VARS.qrCodeStatus) {
                    let qrCodeUrl = await fetchQrCodeUrl(verificationCodes);
                    $('.js_appointment_qrcode').attr('src', qrCodeUrl.url);
                }

                this.$el.find('.js_confirm').attr('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                this.$el.find('.js_confirm').data('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                this.$el.find('.js_confirm').data('hover-style', JS_VARS_THEME_STYLE.mainButtonHoverStyle);

                this.$el.find('.js_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.js_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.js_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);
            }
        });
    }

    $('.js_appointment_detail_btn').on('click', function(){
        const reservationId = $(this).data('reservation-id');
        const reservationBlockDom = $('#js_reservation_' + reservationId);
        const reservationTime = reservationBlockDom.find('.js_reservation_time').text();

        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_appointment'
            }),
            columnClass: 'col-lg-5',
            closeIcon: false,
            icon: '',
            animation: 'opacity',
            animationSpeed: 1000,
            closeAnimation: 'none',
            title: `${ Lang.get('frontend.product.service.reservationTime') }：${reservationTime}`,
            keyboardEnabled: true,
            content: $(".js_appointment_detail").html(),
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.close') + '</span>',
                    btnClass: 'js_cancel btn_cancel btn el_btn md solid el_rounded el_text m-0 order-first'
                }
            },
            onOpenBefore: function() {
                const reservationBlockDom = $('#js_reservation_' + reservationId);

                const reservationProductName = reservationBlockDom.find('.js_reservation_product_name').text();
                const reservationImg = reservationBlockDom.find('.js_reservation_img').attr('src');
                const reservationTime = reservationBlockDom.find('.js_reservation_time').text();
                const reservationDuration = reservationBlockDom.find('.js_reservation_duration').text();
                const reservationQuantity = Number(reservationBlockDom.find('.js_accepted_reservation_quantity').text()) + Number(reservationBlockDom.find('.js_canceled_reservation_quantity').text());

                const reservationCodes = JS_VARS.reservationCodesGroupById[reservationId];

                $('.js_appointment_photo').attr('src', reservationImg);
                $('.js_appointment_name b').text(reservationProductName);
                $('.js_appointment_appointTime').text(reservationTime);
                $('.js_appointment_number').text(reservationQuantity);
                $('.js_appointment_duration').text(reservationDuration);

                let codeDetailHtml = '';
                $.each(reservationCodes, function (index, reservationCode) {
                    codeDetailHtml += getReservationCodeDetailHtml(reservationCode.code, reservationCode.verification_at);
                });

                $('.js_code_list').html(codeDetailHtml);

                this.$el.find('.js_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);

            },
        });
    });

    $(document).on('click', '.js_tab_panels li', function () {
        $('.js_tab_panels li').removeClass('is-active');
        $(this).addClass('is-active');

        $('.js_tab_content').addClass('d-none');
        $('.js_tab_content[data-tab-content="' + $(this).data('tab-panel') + '"]').removeClass('d-none');
    });

    $('.js_rental_appointment_btn').on("click", function(){

        const rentalId = $(this).data('rental-id');
        rentalCertificateData.set.setRentalId(rentalId);
        rentalCertificateData.set.setVerificationCode(JS_VARS.rentalCodesGroupByRentalId[rentalId]);

        $.confirm({
            backgroundDismiss: false,
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_appointment js_rental_certificate_popup'
            }),
            columnClass: 'col-lg-5',
            closeIcon: false,
            icon: '',
            animation: 'opacity',
            animationSpeed: 1000,
            closeAnimation: 'none',
            animateFromElement: false,
            title: `${ Lang.get('frontend.product.service.reservationTime') }：${rentalCertificateData.get.getRentalTime()}`,
            theme: 'el_confirm el_popup_appointment js_rental_appointment_pop',
            keyboardEnabled: true,
            content: $(".js_rental_appointment_popup_used").html(),
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.close') + '</span>',
                    btnClass: 'js_cancel btn_cancel btn el_btn md solid el_rounded el_text m-0 order-first',
                    action: function () {
                        this.$el.find('[data-tab-panel]').eq(0).trigger('click');
                    }
                },
                confirmButton: {
                    keys: ['enter'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.order.reservation.verificationCertificate') + '</span>',
                    btnClass: 'js_use_appointment js_confirm btn_confirm btn el_btn md solid el_rounded el_text m-0',
                    action: function () {
                        $('.js_rental_appointment_pop').hide();
                        secondPopup('rental', $('.js_rental_appointment_pop'), rentalCertificateData.get.getRentalTime(), [rentalCertificateData.get.getVerificationCode()]);
                        return false;
                    }
                }
            },
            onOpenBefore: function() {
                this.$el.find('.js_rental_appointment_product_list').html('');
                rentalCertificateData.get.getProducts().forEach((product) => {
                    this.$el.find('.js_rental_appointment_product_list').append(getRentalProductDetailHtml(product));
                });

                if (rentalCertificateData.get.isUsedVerificationCode()) {
                    this.$el.find('.js_use_appointment').addClass('ui-hidden');
                    this.$el.find('.js_rental_appointment_code_status').html(getRentalUsedCodeHtml(rentalCertificateData.get.getVerificationCode(), rentalCertificateData.get.getUsedVerificationCodeTime()));
                } else {
                    this.$el.find('.js_use_appointment').removeClass('ui-hidden');
                    this.$el.find('.js_rental_appointment_code_status').html(getRentalUnusedCodeHtml(rentalCertificateData.get.getVerificationCode()));
                }

                this.$el.find('.js_rental_appointment_product_count').html(rentalCertificateData.get.getProductCount());

                this.$el.find('.js_confirm').attr('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                this.$el.find('.js_confirm').data('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                this.$el.find('.js_confirm').data('hover-style', JS_VARS_THEME_STYLE.mainButtonHoverStyle);

                this.$el.find('.js_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.js_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.js_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

            }
        });

    });
});
